<!--
 * @Description: 
 * @Author: 长老
 * @Date: 2019-07-31 09:57:55
 * @LastEditTime: 2019-11-05 20:36:38
 * @LastEditors: 陆伟
 -->
<template>
    <div id="share-coupon">
      <!-- 网络异常 -->
      <share-error ref="ShareError" v-if="isShowReload"></share-error>
      <!-- 主页面 -->
      <div class="shareCoupon-content-x" @scroll="handleScrollFn"  v-show="isShowPage">
        <!-- 非单品劵 -->
        <div class="receive-bg" :class="statusBg(nationCouponData.getResultType)" v-if="nationCouponData.single == 0">
          <Coupon-item ref="CouponItem" :nationCouponData="nationCouponData" :couponUser="couponUser" :isShowScopeIcon="isShowScopeIcon"></Coupon-item>
        </div>
        <!-- 单品劵 -->
        <div class="receive-bg" :class="nationCouponData.getResultType != 4 ? 'receive-bg-single' : 'receive-bg-limit'" v-if="nationCouponData.single == 1">
          <Coupon-item ref="CouponItem" :nationCouponData="nationCouponData" :couponUser="couponUser" :isShowScopeIcon="isShowScopeIcon" :singleProduct="singleProduct"></Coupon-item>
        </div>
        <!-- 未生效  注意改两份 OldShareCoupon.vue-->
        <div class="remind-btn1" :class="alreadySubscribe==1?'gray':''" @click="toSubscribe" v-if="showRemindBtn"><p>{{alreadySubscribe == 1 ? '已订阅优惠券生效提醒':'优惠券生效提醒'}}</p></div>
        <!-- 单品按钮 -->
        <div v-for="(item,index) in singleProduct" :key="index">
          <template v-if="nationCouponData.single == 1 && nationCouponData.getResultType != 4 && index < 1">
            <!-- 未生效不显示 -->
            <div class="buy-now" v-if="!(couponUser && couponUser.canUse == 1)" @click="goDetail(item,index,1)">立即购买</div>
            <div class="check-more-d" @click="goMore(0)">查看更多好货></div>
          </template>
        </div>
        <!-- 下半部分 -->
        <div class="next-part" v-if="singleProduct && singleProduct.length > 0 && nationCouponData.single == 0 && (nationCouponData.getResultType === 0 || nationCouponData.getResultType === 1)">
          <div class="shop-titles"><span class="shop-l-bg"></span><span class="shop-title-tip">优惠商品提前看</span><span class="shop-r-bg"></span></div>
            <!-- 用券下单 立享优惠 -->
            <ul class="shop-list ui-rows-wrap ui-rows-justify" ref="recommdHf">
                <li v-for="(item,index) in singleProduct" :key="index" @click="goDetail(item,index,0)">
                  <commodities-list ref="CommoditiesList" :item="item" :index="index"></commodities-list>
                </li>
            </ul>
            <div class="hot-shop-more">
              <span class="more-btn" v-show="!isLastPage && !isMorePage && singleProduct.length > 0" @click="goMoreShop()">查看更多</span>
              <span v-show="isLastPage && singleProduct.length > 0 ">- 没有了哦 -</span>
            </div>
            <div class="check-more" @click="goMore(1)">去首页逛好物</div>
        </div>
        <div class="check-more" @click="goMore(1)" v-if="(nationCouponData.single == 1 && nationCouponData.getResultType == 4) || (nationCouponData.single == 0 && (nationCouponData.getResultType !== 0 && nationCouponData.getResultType !== 1))">去首页逛好物</div>
      </div>
      <!-- 注册 -->
      <RegisterBox ref="reqRef" @reloadPageInfo="reloadPageInfoFn" />
    </div>
</template>

<script type="text/ecmascript-6">
import Vue from 'vue'
import YunJi from '@/assets/js/YunJi'
import * as Util from '@/assets/js/Util'
import wxShare from '../../common/wxShare'
import * as Http from '@/pages/commodity/api/share'
import * as Mark from '@/pages/commodity/api/itemMark'

import ShareError from '@/pages/commodity/components/ShareError'
import CommoditiesList from '@/pages/commodity/components/CommoditiesList'
import RegisterBox from '@/pages/commodity/components/RegisterBox/index'
import CouponItem from '@/pages/commodity/views/ShareCoupon/components/CouponItem'
import { isWxProgram } from '@/assets/js/Util'

let timeouFlag = null
let exposureReportIndex = []
let allShopItemIds = {} // itemtrackdataMap 埋点要的数据

export default {
  name: 'share-coupon',
  data() {
    return {
      alreadySubscribe: 0, // 1已订阅
      shopId: YunJi.getUrlParams('shopId'), // 店铺id
      appCont: YunJi.getUrlParams('appCont') || 0, // 是否app
      couponUserId: YunJi.getUrlParams('fullCouponUserId'), // 优惠券业务id
      sourceConsumerId: YunJi.getUrlParams('sourceConsumerId'), // 赠送人用户id
      isShowPage: false, // 是否显示页面
      isShowReload: false, // 是否显示网络异常
      nationCouponData: {}, // 页面整体信息
      couponUser: { }, // 优惠劵信息
      isShowScope: false,
      isShowScopeIcon: false,
      singleProduct: [], // 商品列表
      markedBuyAttachItemList: [], // 打标买赠商品列表
      currPage: 0, // 当前页
      pageSize: 10,
      totalCount: null, // 商品总页数
      shopItemIds: null,
      isShowBrush: true, // 防止重复刷接口
      isMorePage: false,
      isLastPage: false,
      memberType: 2,  //0:游客 1:钻石会员(包含体验会员) 2:vip (-1,不存在用户)
      recommdHfOffsetTop: -1,
      pageId: '00064'
    }
  },
  computed:{
    showRemindBtn() {
      // getResultType 0 领取成功 1 已领过 2 已抢光 3 领取上限 4 已领取上限
      return this.nationCouponData.getResultType != 2 && this.nationCouponData.getResultType !=4 && this.couponUser && this.couponUser.canUse == 1
    }
  },
  components: { 
    ShareError, 
    CommoditiesList, 
    CouponItem,
    RegisterBox
  },
  activated() {
    
  },
  mounted() {
    if (!YunJi.isWeiXin() && !YunJi.appUA && !YunJi.getUrlParams('debugger')) {
      document.head.innerHTML = '<title>抱歉，出错了</title><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=0"><link rel="stylesheet" type="text/css" href="https://res.wx.qq.com/open/libs/weui/0.4.1/weui.css">'
      document.body.innerHTML = '<div class="weui_msg"><div class="weui_icon_area"><i class="weui_icon_info weui_icon_msg"></i></div><div class="weui_text_area"><h4 class="weui_msg_title">请在微信客户端打开链接</h4></div></div>'
    }
    wxShare({}, 'hide') // 隐藏微信分享
    exposureReportIndex = []
    allShopItemIds = {} 
    this.getnationCoupon()
    // setTimeout(() => {
    //   this.$refs.reqRef.showDialog()
    // }, 2000)
  },
  beforeDestroy() {

  },
  methods: {
    reloadPageInfoFn() {
      console.log('刷新数据：：：：')
      exposureReportIndex = []
      allShopItemIds = {} 

      this.getnationCoupon()
    },
    toSubscribe() {
      // 排除 已订阅 
      if(this.alreadySubscribe == 1) return

      window.thinkingReport.track('others', {
        page_id: '80611',
        point_id: '29272'
      })

      if(this.appCont == 7) {
        this.toExportItem()
        const {origin,pathname,search} = window.location
        wx.miniProgram.navigateTo({
          url:`/mall/pages/share-coupon/share-coupon?linkUrl=${encodeURIComponent(origin + pathname)}&subscribeCouponUserId=${this.couponUser.fullcouponUserId}&${search.split('?')[1]}`
        })
      } else {
        Http.toSubscribe({fullCouponUserId: this.couponUser.fullcouponUserId,appCont: this.appCont}).then((res) => {
          this.alreadySubscribe = res.code == 0 && res.data && res.data.subscribe == 1 ? 1 : 0
          // 失败提示
          Toast(res.msg)
        })
      }
    },
    /**
     * 获取优惠劵信息
     */
    getnationCoupon() {
      const params = {
        fullCouponUserId: this.couponUserId,
        sourceConsumerId: this.sourceConsumerId
      }
      Http.getCoupon(params).then((res) => {
        if (res.errorCode === parseFloat(Util.ERR_CODE)) {
          this.isShowPage = true // 显示页面
          this.nationCouponData = res.data || {} // 基础信息
          this.alreadySubscribe = this.nationCouponData.alreadySubscribed || 0
          // res.data.couponUser.canUse = 1
          this.couponUser = res.data.couponUser || {} // 优惠劵信息
          // 未生效埋点
          if(this.couponUser.canUse == 1) {
            window.thinkingReport.track('exposure', {
              page_id: '80611',
              point_id: '29271',
              content_type:  this.nationCouponData.single == 1 ? '单品券' : '多品券'
            })
            // 未订阅
            if(this.alreadySubscribe != 1) {
              window.thinkingReport.track('exposure', {
                page_id: '80611',
                point_id: '29273'
              })
            }
          }
          if (res.data.single === 0) {
            if(res.data.getResultType === 0 || res.data.getResultType === 1) {
              this.getShopId() // 非单品劵商品列表
            }
          } else if (res.data.single === 1) {
            if (res.data.getResultType === 4) {
              // this.getShopId() // 单品劵商品列表失效调用
            } else {
              this.getSingleDetail() // 单品劵商品
            }
          }
          this.$nextTick(() => {
            const screenWidth = window.screen.availWidth
            if (screenWidth < 360) { // 截取字符串的长度
              if (this.couponUser.scopeName && ((this.couponUser.scopeName.length + (this.couponUser.useScopeDesc ? this.couponUser.useScopeDesc.length + 2 : 0)) < 27)) {
                this.isShowScopeIcon = false
              } else {
                this.isShowScopeIcon = true
              }
            } else if (screenWidth >= 360) {
              if (this.couponUser.scopeName &&((this.couponUser.scopeName.length + (this.couponUser.useScopeDesc ? this.couponUser.useScopeDesc.length + 2 : 0)) < 28)) {
                this.isShowScopeIcon = false
              } else {
                this.isShowScopeIcon = true
              }
            }
            if (this.nationCouponData.getterNickName && this.nationCouponData.getterNickName.length > 6) {
              this.nationCouponData.getterNickName = `${this.nationCouponData.getterNickName.substr(0, 6)}...`
            }
          })
          // 埋点
          this.thinkingReport('page_load', {
            point_id: '21554'
          })
        } else if(res.errorCode == 1000) {
          // 未注册手机号
          this.$refs.reqRef.showDialog()
        } else if (res.errorCode !== 2418) {
          this.isShowReload = true // errorCode != 0 显示重新加载
        }
      }).catch(() => {
        this.isShowReload = true // errorCode != 0 显示重新加载
      })
    },
    handleScrollFn(e) {
      if (this.singleProduct.length <= 2) return
      this.setExportMark(e.srcElement.scrollTop || e.target.scrollTop)
    },
    // 设置离开曝光标示
    setExportMark(scrollTop) {
      if(timeouFlag) {
        clearTimeout(timeouFlag)
        timeouFlag = null
      }
      if(this.recommdHfOffsetTop <= 0 || !this.$refs.recommdHf) return
      if(scrollTop <= 0) return
      timeouFlag = setTimeout(() => {
        // 滚动条距离+页面高度- 推荐模块到顶部进来 / 每个卡片的高度
        const fixHeight = window.screen.height + scrollTop - (this.recommdHfOffsetTop + YunJi.remToPx(5.46/2))
        if(fixHeight > 0){  
          const diffItemIndex = Math.ceil(fixHeight/YunJi.remToPx(5.46)) * 2 ;//曝光的商品下标
          if(exposureReportIndex.findIndex(i => i == diffItemIndex) < 0){
            exposureReportIndex.push(diffItemIndex)
            // 设置标示 标示已经曝光过了 离开曝光的时候就是根据这个标示上报埋点
            this.singleProduct.forEach((o,index) => {
              if(index < diffItemIndex) {
                o.needExport = true
              }
            })
          }
        }
      },500)
    },
    // 上报埋点
    toExportItem() {
      const exportGoods = this.singleProduct.filter(o => o.needExport)
      const itemtrackdataList = []
      const itemIds = []
      // 拼装上报参数
      if(exportGoods.length > 0) {
        exportGoods.forEach((o) => {
          if(o) {
            itemtrackdataList.push(allShopItemIds[`${o.itemId}`])
            itemIds.push(`ITM_${o.itemId}`)
          }
        })
        // 执行埋点上报
        thinkingReport.track('exposure', {
          page_id: 80611,
          point_id: 29283,
          identity_type: this.memberType == 1 ? 'shop' : 'vip',
          page_track_data: itemtrackdataList.join(','), // 把离开曝光的每个商品的itemtrackdata进行拼接
          content_id: itemIds.join(','), // 离开时用户浏览过的商品，格式 ：ITM_itemID
          index: exposureReportIndex[exposureReportIndex.length-1], // 走的时候浏览到的最大商品序号
          module_name: '优惠券分享页' 
        })
      }
    },
    /**
     * 获取商品ID
     */
    getShopId() {
      const params = {
        consumerId: this.couponUser.consumerId,
        couponUserId: this.couponUserId,
        pageIndex: this.currPage,
        pageSize: this.pageSize
      }
      if (!this.isShowBrush) return
      this.isShowBrush = false
      Http.getPersonalItemByCoupon(params).then((res) => {
        this.isShowBrush = true
        if (res.errorCode === parseFloat(Util.ERR_CODE)) {
          const resData = res.data || {}
          this.totalCount = resData.totalCount
          this.shopItemIds = resData.itemId
          this.memberType = resData.memberType || 2
          allShopItemIds = Object.assign({},allShopItemIds,resData.itemtrackdataMap || {})
          this.$nextTick(() => {
            if (this.shopItemIds) {
              this.isMorePage = true
              this.getSingleDetail()
            }
          })
        }
      }).catch(() => {
        this.isShowBrush = true
      })
    },
    /**
     * 加载更多商品列表信息
     */
    goMoreShop() {
      this.currPage += 1
      this.getShopId()
    },
    /**
     * 获取单品劵信息
     */
    getSingleDetail() {
      const prams = {}
      if (this.nationCouponData.single === 1 && this.nationCouponData.getResultType !== 4) {
        prams.itemIdStr = this.nationCouponData.couponUser.useScopeValue
      } else {
        prams.itemIdStr = this.shopItemIds
      }
      Http.getBatchItemByIds(prams).then((res) => {
        this.isShowBrush = true
        if (res.errorCode === parseFloat(Util.ERR_CODE)) {
          res.data.forEach((item) => {
            this.singleProduct.push(item)
          })
          const totalPage = Math.ceil(this.totalCount / this.pageSize) // 总页数
          if ((parseFloat(this.currPage) + 1) >= totalPage) {
            this.currPage = totalPage
          }
          if (totalPage === this.currPage) {
            this.isLastPage = true
          } else {
            this.isLastPage = false
          }
          // 为了做离开曝光埋点 记录一下 推荐模块到顶部的offsetTop
          setTimeout(()=>  {
            if(this.recommdHfOffsetTop <= 0 && this.$refs.recommdHf) {
              this.recommdHfOffsetTop = this.$refs.recommdHf.offsetTop - 10
              this.setExportMark(2)
            }
          },500)

          const itemIds = {
            appCont: this.appCont,
            strVersion: '1',
            itemIds: this.shopItemIds,
            businessMarkType: '1'
          }
          Mark.getItemMark(itemIds).then((res) => {
            if (res.errorCode === parseFloat(Util.ERR_CODE) && res.data) {
              this.markedBuyAttachItemList = res.data
              // 动态在商品列表里面创建 字段 markFlag
              for (let i = 0; i < this.singleProduct.length; i += 1) {
                for (let j = 0; j < this.markedBuyAttachItemList.length; j += 1) {
                  if (this.singleProduct[i].itemId === this.markedBuyAttachItemList[j].itemId) {
                    Vue.set(this.singleProduct[i], 'markFlag', this.markedBuyAttachItemList[j].mark)
                    Vue.set(this.singleProduct[i], 'markDescribe', this.markedBuyAttachItemList[j].markDescribe)
                  }
                }
              }
              this.isMorePage = false
            }
          })
        }
      })
    },
    /**
     * 根据不同的状态显示不同的背景
     * 默认 0, "恭喜你，已成功领取优惠券"，1,"已领过"，2, "抢光了"，3, "今日已达领取上限"，4, "优惠券已失效"
     * single 是否是单品：默认0-非，1-是
     */
    statusBg(status, single) {
      let statusInfo = null
      if (status === 2) {
        statusInfo = 'receive-bg-loot-all'
      } else if (status === 3 || status === 4) {
        statusInfo = 'receive-bg-limit'
      } else if (single === 1) {
        statusInfo = 'receive-bg-single'
      }
      return statusInfo
    },
    /**
     * 跳转至对应的商品详情
     * @param item 商品对象
     * @param index 商品位置
     * @param type 不同的按钮 0 商品列表 ,  1 立即购买
     */
    goDetail(item, index, type) {
      this.toExportItem()
      if (type === 0) {
        this.thinkingReport('others', {
          point_id: '21560',
          item_id: item.itemId,
          index: index
        })
      } else if (type === 1) {
        this.thinkingReport('others', {
          point_id: '21556'
        })
      }
      if (isWxProgram()) {
        wx.miniProgram.navigateTo({ url: `/pages/detail/detail?itemId=${item.itemId}&origin=1&shopId=${this.nationCouponData.giveShopId}` })
        return
      }
      window.location.href = `//${window.globalConfig.buyerBasePath}/yjbuyer/detail?itemId=${item.itemId}&shopId=${this.nationCouponData.giveShopId}`
    },
    /**
     * 查看更多好货---跳转去更多特卖逛逛
     */
    goMore(type) {
      this.toExportItem()
      this.thinkingReport('others', {
        point_id: type === 0 ? '21557' : '21558'
      })
      if (isWxProgram()) {
        if (+type) {
          wx.miniProgram.switchTab({ url: `/pages/index/index?shopId=${this.nationCouponData.giveShopId}` })
        } else {
          // wx.miniProgram.switchTab({ url: `/pages/99activity/99activity?shopId=${this.nationCouponData.giveShopId}` })
          wx.miniProgram.switchTab({ url: `/pages/index/index?shopId=${this.nationCouponData.giveShopId}` })
        }
        return
      }
      window.location.href = `//${window.globalConfig.buyerBasePath}/yjbuyer/more?shopId=${this.nationCouponData.giveShopId}&appCont=0&sourceConsumerId=${this.sourceConsumerId}`
    },
    // 埋点封装
    thinkingReport(event_name, param) {
      let getResultType = this.nationCouponData.getResultType
      let useScope = this.couponUser.useScope
      window.thinkingReport.track(event_name, {
        ...param,
        page_id: this.pageId,
        content_type: useScope === 0 ? '全场通用' : 
          useScope === 1 ? '限指定类目' : 
          useScope === 2 ? '限指定商品' : 
          useScope === 3 ? '指定品牌团' : 
          useScope === 4 ? '限指定专题' : 
          useScope === 5 ? '超市商品' : 
          useScope === 6 ? '手机话费充值专用' :  '指定店铺',
        business_state: getResultType === 0 ? '领取成功' : 
          getResultType === 1 ? '已领过' : 
          getResultType === 2 ? '抢光了' : 
          getResultType === 3 ? '今日已达领取上限' : '已失效'
      })
    }
  }
}
</script>

<style>
/*主页面*/
.shareCoupon-content-x { position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-image: linear-gradient(-159deg, #DE44FF 0%, #720BB5 95%); box-sizing: border-box; overflow: auto;overflow-x: hidden;}
.next-part { margin-bottom: .4rem;}
.receive-bg { margin: .18rem auto 0 auto; width: 7.14rem; height: 7.6rem; background: url('//static.yunjiweidian.com/qnUpload/frontend/shareCoupon/share-bg.png') no-repeat; background-size: 100% 100%;}
/*抢光了*/
.receive-bg.receive-bg-loot-all { height: 6.2rem; background: url('//static.yunjiweidian.com/qnUpload/frontend/shareCoupon/share-bg-all.png') no-repeat; background-size: 100% 100%;}
/*上限、失效*/
.receive-bg.receive-bg-limit { min-height: 5.56rem; background: url('//static.yunjiweidian.com/qnUpload/frontend/shareCoupon/share-bg-limit.png') no-repeat; background-size: 100% 100%;}
/*单品*/
.receive-bg.receive-bg-single { height: 9.18rem; background: url('//static.yunjiweidian.com/qnUpload/frontend/shareCoupon/share-bg-single.png') no-repeat; background-size: 100% 100%;}
/*头像*/
.head-portrait-data { margin-top: .18rem; width: 100%; text-align: center;}
.head-portrait { margin: 0 auto; width: .88rem; height: 1.36rem; padding-top: .48rem;}
.head-portrait img { width: 100%; height: 100%; border-radius: 50%; -webkit-border-radius: 50%;}
.head-name { margin: .2rem auto 0 auto; opacity: 0.8; font-size: .24rem; color: #fff; min-height: .32rem; max-width: 5.84rem; overflow: hidden;  white-space: nowrap; text-overflow: ellipsis;}
.head-tip { margin: .18rem auto 0 auto; width: 5.84rem; text-align: center; height: .6rem; line-height: .6rem; color: #212121; font-size: .28rem; background: rgba(255,255,255,0.15); border-radius: 15px; -webkit-border-radius: 15px; position: relative;}
.triangle{ position: absolute; top: -5px; left: 50%; margin-left: -5px; width: 0; height: 0; border-bottom: 5px solid rgba(255,255,255,0.15); border-left: 5px solid transparent; border-right: 5px solid transparent;  }
/*领取文案*/
.receive-success { margin-top: .5rem; width: 100%; text-align: center; font-size: .48rem; color: #fff; font-weight: 700;}
/*领取优惠劵*/
.coupon-info { margin: .5rem auto 0 auto; width: 6.34rem;}
.no-voucher { width: 100%;}
.coupon-cont, .voucher { width: 100%; min-height: 1.9rem; background: url('//static.yunjiweidian.com/qnUpload/frontend/shareCoupon/coupon-bg.png') no-repeat left top; background-size: 100%;}
.coupon-cont {padding-top: .46rem; }
.coupon-cont-l { width: 2.6rem; height: 1rem; float: left; border-right: 1px solid #ddd; color: #F10D3B; font-size: 1rem; text-align: center; line-height: 1rem;}
.coupon-cont-l i { font-style: normal; font-size: .48rem;}
.coupon-cont-r { float: left; margin-left: .48rem; color: #F10D3B;}
.coupon-cont-r .coupon-title {color: #212121; font-size: .24rem;}
.coupon-cont-r .coupon-full { margin-top: .06rem; font-size: .24rem;}
.coupon-put-in-text {opacity: 0.8; color: #fff; font-size: .24rem; width: 100%; text-align: center; margin-top: .24rem;}
.coupon-put-in-text span {color: #FFE70A; font-weight: 700;}


.coupon-invalid { width: 100%; text-align: center; font-size: .6rem; line-height: 1.9rem; color: #C8C8C8;}
.coupon-finish { width: 100%; text-align: center;}
.coupon-finish-t { display: block; padding-top: .85rem; font-size: .4rem;color: #212121;}
.coupon-finish-s { display: block; margin-top: .24rem; font-size: .28rem; color: #666; min-height: .24rem}
.coupon-end { margin-top: .32rem; width: 100%; text-align: center; opacity: 0.8; font-size: .24rem; color: #fff; line-height: .4rem;}
.coupon-end .coupon-img { width: .4rem; height: .4rem; -webkit-border-radius: 50%; border-radius: 50%; vertical-align: middle;}
.coupon-end span {color: #FFE70A;}

.coupon-single { width: 100%; height: 2.06rem; padding: .26rem .2rem 0 .2rem; background: #fff url('//static.yunjiweidian.com/qnUpload/frontend/shareCoupon/division.png') no-repeat top center; background-size: 100%;}
.coupon-single-l { width: 1.6rem; height: 1.6rem;}
.coupon-single-l img { width: 100%; height: 100%;}
.coupon-single-r { margin-left: .2rem; max-width: 3.8rem;}
.coupon-zhu-title { font-size: .24rem; color: #212121; font-weight: 700;}
.coupon-sub-title {  color: #666;}
.item-price{height: .4rem;line-height: .4rem; margin-top: .16rem;}
.item-curr-price{font-size: .28rem;color: #F10D3B;font-weight: 600;}
.item-pre-price{font-size: .24rem;color: #9A9A9A;text-decoration: line-through;margin-left: .1rem;}
.item-pre-price .price-right{font-weight: normal;}
.price-right{margin-right: 2px;font-weight: 600;}

.hot-shop-more { margin: .2rem auto 0 auto; width: 100%; height: .38rem; font-size: .2rem; text-align: center; color: #fff;}
.hot-shop-more .more-btn { display: inline-block; width: 1.86rem; height: .34rem; line-height: .4rem; border-radius: 2rem; -webkit-border-radius: 2rem; border: 1px solid #fff; color: #fff;}
.ui-cols-10 {-webkit-box-flex: 0;-webkit-flex: 0 0 10%;-moz-box-flex: 0;-moz-flex: 0 0 10%;-ms-flex: 0 0 10%;flex: 0 0 10%;max-width: 10%;}
.scope-icon{top:0}
.scope-one{word-break: break-all;}
.coupon-cont-r .coupon-title{width: 3rem;}

/*立即购买/查看更多好货*/
.check-more,.buy-now { margin: .6rem auto 0 auto; background-image: linear-gradient(-90deg, #F10D3B 0%, #FF5C00 100%); border-radius: 22px; -webkit-border-radius: 22px; font-size: .3rem; color: #fff; width: 6.7rem; height: .88rem; line-height: .88rem; text-align: center;}
.check-more-d { margin-top: .32rem; font-size: .3rem; color: #fff; text-align: center;}

.checkCoupons{
  margin: 0.1rem 0;
}

.remind-btn1{
  background: #E24CCA;
  border-radius: 0 0 4px 4px;
  padding: .36rem .4rem;
  width: 7.14rem;
  margin: -.04rem auto 0;
}
.remind-btn1 p{
  background-image: linear-gradient(148deg, #FE5B00 0%, #F10F39 100%);
  border-radius: .44rem;
  font-size: .32rem;
  color: #FFFFFF;
  display: flex;
  height: .88rem;
  align-items: center;
  justify-content: center;
}
.remind-btn1.gray p{
  background: #999999;
}

</style>
